import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { CreateOfferPayload } from 'v2/interfaces/product';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
} & CreateOfferPayload;

export function useCreateProductOffer(options: UseMutationOptions<void, unknown, Payload> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ productId, ...payload }: Payload) => productService.createOffer(productId, payload),
    ...options,
    onSuccess: (...args) => {
      const [, { productId }] = args;
      queryClient.removeQueries({ queryKey: ['product', productId] });
      queryClient.invalidateQueries({ queryKey: ['products', productId, 'offers'] });
      options.onSuccess?.(...args);
    }
  });
}
